import HubSpotForm from '@web/components/HubspotForm'

export default function ContactSection({ isInternalPage = false }: { isInternalPage: boolean }) {
  return (
    <div id="contact-section" className="relative px-6 py-24 isolate sm:py-32 lg:px-8">
      <div className="max-w-xl mx-auto lg:max-w-4xl">
        {isInternalPage ? (
          <h2 className="mb-16 text-4xl font-light leading-tight tracking-tight text-text-primary sm:text-5xl lg:text-[52px] lg:leading-tight">
            Contact
          </h2>
        ) : (
          <h2 className="mb-16 text-4xl font-light leading-tight tracking-tight text-text-primary sm:text-5xl lg:text-[52px] lg:leading-tight">
            Ready to understand
            <br />
            your risks and build resilience?
          </h2>
        )}
        <div className="flex flex-col-reverse gap-16 mt-16 md:flex-col sm:gap-y-20 lg:flex-row">
          <div className="w-full lg:w-[500px] -ml-8">
            <HubSpotForm />
          </div>

          <div className="lg:mt-6 lg:w-80 lg:flex-none">
            <div className="aspect-[4/5] w-full overflow-hidden ">
              <img
                alt=""
                src="/website/contact-image.png"
                className="object-cover object-center w-full h-full"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
